import type { IframeMessage } from "@trello-powerup-monorepo/iframe-messenger-v2";
import type { PaywallMessage } from "../types";
import { PAYWALL_MESSAGE_TYPE_VALUES } from "../constants";

// AIDEV-NOTE: Shared guard to narrow IframeMessage to PaywallMessage without unsafe casts
export const isPaywallMessage = (
  message: IframeMessage
): message is PaywallMessage => {
  return PAYWALL_MESSAGE_TYPE_VALUES.includes(message.type as any);
};

